import {
  COMPANY_LIST,
  COMPANY_LIST_PAGINATION,
  CREATE_COMPANY,
  DELETE_COMPANY,
  EDIT_COMPANY,
  IMPORT_COMPANY_DATA,
} from "./apiRoutes";
import { authData } from "./Service";

export const listOfCompanyApi = async (data) => {
  const response = await authData.post(COMPANY_LIST, data);
  return response?.data;
};

export const listOfCompanyWithPaginationApi = async (data) => {
  const response = await authData.post(COMPANY_LIST_PAGINATION, data);
  return response?.data;
};

export const createCompanyApi = async (data) => {
  const response = await authData.post(CREATE_COMPANY, data);
  return response?.data;
};

export const editCompanyApi = async (data) => {
  const response = await authData.put(EDIT_COMPANY, data);
  return response?.data;
};

export const deleteCompanyApi = async (id) => {
  const response = await authData.delete(`${DELETE_COMPANY}${id}`);
  return response?.data;
};

export const importCompanyDataApi = async (data) => {
  const response = await authData.post(IMPORT_COMPANY_DATA, data);
  return response?.data;
};
